import { render, staticRenderFns } from "./ConfirmSceneDeleteDialog.vue?vue&type=template&id=b893c572&scoped=true"
import script from "./ConfirmSceneDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmSceneDeleteDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSceneDeleteDialog.vue?vue&type=style&index=0&id=b893c572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b893c572",
  null
  
)

export default component.exports